import * as React from 'react';

function SvgAssociatedFieldIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#21BA30" />
      <path
        d="M13.14 13.527l-1.667-1.667a.67.67 0 10-.946.947l.533.526H8.667v-2.666a.667.667 0 10-1.333 0v6.666a.667.667 0 101.333 0v-2.666h2.393l-.533.526a.665.665 0 000 .947.665.665 0 00.947 0l1.666-1.667a.667.667 0 00.14-.22.667.667 0 000-.506.667.667 0 00-.14-.22zM20 10a.666.666 0 00-.666.667v2.666H16.94l.534-.526a.669.669 0 10-.947-.947l-1.667 1.667a.665.665 0 00-.14.22.666.666 0 000 .506c.032.082.08.157.14.22l1.667 1.667a.665.665 0 00.947 0 .666.666 0 000-.947l-.534-.526h2.393v2.666a.666.666 0 101.334 0v-6.666A.667.667 0 0020 10z"
        fill="#232340"
      />
    </svg>
  );
}

export default SvgAssociatedFieldIcon;
